module.exports = __webpack_public_path__ + "img/Social_Studies_3.4d2eeae1.svg";